import apiClient from "../apiClient";

const resource = "doctorPrescriptions";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: (id,doctorId )=> apiClient.get(`${resource}/${id}/details?doctorId=${doctorId}`),
    getForEdit: (id,doctorId ) => apiClient.get(`${resource}/${id}?doctorId=${doctorId}`),
    add: payload => apiClient.post(`${resource}`, payload),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    delete: (id,doctorId ) => apiClient.delete(`${resource}/${id}?doctorId=${doctorId}`),
    cancel: (id,doctorId ) => apiClient.put(`${resource}/${id}/cancel?doctorId=${doctorId}`),
    getMedicinesStock: params => apiClient.get(`${resource}/medicineStock?${params}`),
    getAppointments: id => apiClient.get(`${resource}/appointments?doctorId=${id}`),
    getPatients: date => apiClient.get(`${resource}/patients?AppointmentDate=${date}`),
    getForPrint: id => apiClient.get(`${resource}/${id}/print`),

};
